module.exports = __webpack_public_path__ + "img/教育领域.0ae29a7e.jpg";